import { TYPE_TEAMS } from '@/constants';
import PathManager from '@/models/PathManager';

export default class GroupManager {
  constructor() {
    this.groupList = [];
    this.pathManager = new PathManager();
  }

  get groupTypes() {
    return [...new Set(this.groupList.map((group) => group.type))];
  }

  processByTick() {
    this.pathManager.processByTick();

    this.groupList.forEach((group) => {
      if (group.constructor.name !== 'Product') {
        group.processByTick();
      }

      // 有更好的寫法嗎？
      // 怎麼挑？
      // 挑完更新 group 的方式不能：1. 直接更新 2. 比對
      if (group.skills?.deliveryQueue) {
        const tasksUnselected = [];
        const tasks = group.skills.deliveryQueue.getList();
        for (let i = 0; i < tasks.length; i += 1) {
          const targetTeam = this.findTargetTeam(tasks[i]);
          if (targetTeam) {
            this.pathManager.addTask({
              task: tasks[i],
              sourceTeam: group,
              targetTeam,
            });
          } else {
            tasksUnselected.push(tasks[i]);
          }
        }
        group.skills.deliveryQueue.updateList(tasksUnselected);
      }
    });
  }

  addGroup(item) {
    this.groupList.push(item);
    this.pathManager.updatePathGraph(item);
  }

  findAvailableRoomByType(roomType) {
    return this.groupList.find((group) => group.type === roomType && group.hasEmptySeat);
  }

  findTargetTeam(task) {
    const targetTeamType = this.findTargetTeamType(task);
    const teams = this.groupList
      .filter((group) => group.type === targetTeamType);

    let targetTeam;
    let min = Number.POSITIVE_INFINITY;
    teams.forEach((team) => {
      const loading = team.workload + this.pathManager.getPacketWorkload(team.name);
      if (loading < min) {
        min = loading;
        targetTeam = team;
      }
    });
    return targetTeam;
  }

  findTargetTeamType(task) {
    switch (task.constructor.name) {
      case 'Story':
        if (this.groupTypes.indexOf(TYPE_TEAMS.PM) !== -1) {
          return TYPE_TEAMS.PM;
        }
        return TYPE_TEAMS.RD;
      case 'Wireframe':
        if (this.groupTypes.indexOf(TYPE_TEAMS.UX) !== -1) {
          return TYPE_TEAMS.UX;
        }
        return TYPE_TEAMS.RD;
      case 'Spec':
        return TYPE_TEAMS.RD;
      case 'Feature':
        return TYPE_TEAMS.QA;
      case 'Bug':
        return task.acceptTeamType;
      default:
        return '';
    }
  }

  // eslint-disable-next-line class-methods-use-this
  findTaskNextTeam(teamType) {
    const order = [
      TYPE_TEAMS.PM, TYPE_TEAMS.UX, TYPE_TEAMS.RD, TYPE_TEAMS.QA,
    ];
    let nextIndex = order.findIndex((type) => type === teamType) + 1;
    let nextTeam;
    while (order[nextIndex]) {
      nextTeam = this.groupList
        // eslint-disable-next-line no-loop-func
        .filter((group) => group.type === order[nextIndex])
        .find((team) => team.memberList.find((member) => member.isIdle));
      if (nextTeam) {
        break;
      }
      nextIndex += 1;
    }
    return nextTeam;
  }
}
